export const apificate = (state, getters) => {
  let {
    residence,
    corporateName,
    tradeName,
    document,
    address,
    registrationData,
    medium
  } = state
  return {
    residence,
    name: corporateName,
    tradeName,
    document,
    address,
    registrationData,
    medium
  }
}
